import { createAction, props } from '@ngrx/store';
import { IExpenseData, IExpenseModel } from '@partners/api';

export class ExpenseActions {
  static reset = createAction('[Expense] Reset State');
  static load = createAction('[Expense] Load');
  static loadSuccess = createAction('[Expense] Load Success', props<{ model: IExpenseModel; data: IExpenseData }>());
  static loadFailure = createAction('[Expense] Load Failure', props<{ error: any }>());
  static submit = createAction('[Expense] Submit', props<{ model: IExpenseModel }>());
  static submitSuccess = createAction('[Expense] Submit Success', props<{ data: IExpenseData }>());
  static submitFailure = createAction('[Expense] Submit Failure', props<{ error: any }>());
}
